import { Record } from 'immutable';

export default class OccupationNameRecord extends Record({
  id: undefined,
  active: undefined,
  code: undefined,
  name: undefined,
  vendorId: undefined,
}) {
}
